const login = require('./zh-cn/login')
const verify = require('./zh-cn/verify')
const header = require('./zh-cn/header')
const common = require('./zh-cn/common')
const footer = require('./zh-cn/footer')
const product = require('./zh-cn/product')
const productDetail = require('./zh-cn/productDetail')
const userCenterMenu = require('./zh-cn/userCenter/menu')
const userCenter = require('./zh-cn/userCenter/index')
const auth = require('./zh-cn/auth')
const classify = require('./zh-cn/classify/index')
const My = require('./zh-cn/my')
module.exports = {
  login,
  verify,
  header,
  common,
  footer,
  product,
  productDetail,
  userCenterMenu,
  userCenter,
  auth,
  classify,
  My
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh-cn.js